import { useEffect, useState } from 'react';
import { useAlertStore } from '../../../store/use-alert-store';
import { Alert } from '../alert';
import s from './alert-container.module.css';
import cn from 'classnames';

export const AlertContainer = () => {
  const { alerts, remove } = useAlertStore();
  const [openAlerts, setOpenAlerts] = useState<string[]>([]);

  useEffect(() => {
    setOpenAlerts(alerts?.map((item, index) => item.id || String(index)) || []);

    const timers = alerts?.map((alert, index) =>
      setTimeout(() => !alert.endless && remove(alert.id || String(index)), 5000),
    );

    return () => timers?.forEach(clearTimeout);
  }, [alerts, remove]);

  return (
    <ul className={s.component}>
      {alerts?.map((notification, index) => {
        const id = notification.id || String(index);

        return (
          <Alert
            key={id}
            className={cn(s.item, openAlerts.includes(id) && s.open)}
            alert={notification}
            onClose={() => remove(id)}
          />
        );
      })}
    </ul>
  );
};
